import axios from "../axiosInstance";

class PoleService {
  async listPole() {
    return axios.get("poles");
  }

  async listPoleByUser() {
    return axios.get("poles/by-user");
  }

  async getPolosByUserId(userId) {
    return axios.get(`poles/by-userid?userId=${userId}`);
  }

  async AddMultiplePolesToUser(userAd, poleIds) {
    return axios.post(`poles`, {
      "userId": userAd,
      "poles": poleIds
    });
  }

  async deleteUserPoles(userAd, poleIds) {
    return axios.delete(`poles/userpole`, {
      data: {
        "userId": userAd,
        "poles": poleIds
      }
    });
  }
}

export default new PoleService();
